/* ==========================================================================
   mo-motion.js — Mollaoglou kaydırma hareketi (reveal) motoru
   --------------------------------------------------------------------------
   ~3 KB. Bağımlılık yok. GSAP yok, kütüphane yok.

   MİMARİ İLKE (mollaoglou.js'in kendi başlığından):
     «Reveal/parallax = saf CSS. JS yalnızca CSS'in yapamadığını yapar.»
   Burada JS'in tek işi: «eleman ekrana girdi mi» tespiti + sıra gecikmesi.
   Görsel işin tamamı mo-motion.css'te.

   🔴 ÖNEMLİ: Bu dosya <head> içinde, `defer` OLMADAN yüklenmeli.
   İlk iş olarak `html.mo-rv-ready` sınıfını ekler ve CSS'teki gizli
   başlangıç durumu SADECE o sınıfa bağlıdır. Dosya yüklenmezse veya bir
   sözdizimi hatası verirse sınıf hiç eklenmez → sayfa animasyonsuz ama
   TAM görünür kalır. (Bu projede tam tersi bir kez yaşandı ve içerik
   opacity:0'da kalmıştı — güvenlik zinciri o yüzden bu kadar ayrıntılı.)
   ========================================================================== */
(function () {
  'use strict';

  var root = document.documentElement;

  /* --- 1. Kullanıcı hareket istemiyorsa hiç başlama ----------------------- */
  var mq = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  if (mq && mq.matches) return;

  /* --- 2. Tarayıcı desteği yoksa hiç başlama ----------------------------- */
  if (!('IntersectionObserver' in window)) return;

  /* --- 3. CSS kapısını aç ------------------------------------------------ */
  root.classList.add('mo-rv-ready');

  /* --- 4. Açılış hareketi -----------------------------------------------
     `mo-intro` sınıfı ilk boyamadan ÖNCE eklenmeli, yoksa kahraman bölüm
     bir an tam görünüp sonra animasyona başlar (göze çarpan sıçrama).
     Bu dosya <head> içinde defer'siz yüklendiği için burası doğru an.
     Animasyonlar bitince sınıf kaldırılıyor — geriye hiçbir kural kalmasın,
     hero'nun kendi slider geçişleri serbest çalışsın.                      */
  var INTRO_MS = 2600;
  root.classList.add('mo-intro');
  setTimeout(function () { root.classList.remove('mo-intro'); }, INTRO_MS);

  /* Seçici listesi — mo-motion.css'teki listeyle BİREBİR aynı olmalı.
     Kap-seviyesi seçiciler bilinçli: zaten `transform` taşıyan elemanlara
     (.moh-mq__row, .moh-river__row, .moh-pcard) dokunulmuyor, onları
     SARAN kap hareket ediyor.                                             */
  var GROUPS = [
    /* --- anasayfa --- */
    '.mo-home .moh-cat',                      /* 7 reyon kartı        */
    '.mo-home .moh-job',                      /* 6 erga kartı         */
    '.mo-home .moh-rail',                     /* ürün rayı (kap)      */
    '.mo-home .moh-brands',                   /* marka şeridi (kap)   */
    '.mo-home .moh-river',                    /* 2 renk nehri (kap)   */
    '.mo-home .moh-palette',                  /* renk paleti (kap)    */
    '.mo-home .moh-news .moh-in',             /* newsletter (tek blok)*/

    /* --- erga (iş rehberi) sayfaları --- */
    '.mo-scene__tile',                        /* sahne karoları       */
    /* 2026-08-18: .mo-sc__row / .mo-mat__row / .mo-faq__item CIKARILDI —
       ucu de OKUNAN icerik. Bu dosyanin blog bolumundeki kuralla ayni gerekce:
       okuma sirasinda metnin belirmesini beklemek can sikici. Hareket artik
       yalniz kart/blok seviyesinde. */
    '.mo-hub-card',                           /* ilgili rehber kartları */
    '.mo-erga-hero__badges li',               /* kahraman rozet çipleri */

    /* --- blog makalesi ---
       🔴 Gövde paragrafları (`p`) BİLEREK yok: okuma sırasında metnin
       belirmesini beklemek can sıkıcı. Sadece bölüm işaretleri hareket
       ediyor. Buraya `.article-container p` EKLEME.                     */
    '.article-container h2',
    '.article-container ul',
    '.article-template__social-sharing'
  ];

  var io = null;
  var step = 60;
  var ioFired = false;

  function readStep() {
    var n = parseFloat(getComputedStyle(root).getPropertyValue('--mo-rv-step'));
    return isNaN(n) ? 60 : n;
  }

  function finish(el) {
    el.setAttribute('data-mo-rv', 'done');
    el.style.willChange = '';
    el.style.removeProperty('--mo-rv-d');
  }

  function onEntries(entries) {
    ioFired = true;

    /* Aynı geri çağrımda giren elemanları grubuna göre sırala ki «dalga»
       hissi doğsun. Farklı zamanlarda girenler sıfır gecikme alır —
       kullanıcı yavaş kaydırıyorsa her kart tek tek, hızlı kaydırıyorsa
       dalga hâlinde gelir. İkisi de doğru his.                            */
    var byGroup = {};

    for (var i = 0; i < entries.length; i++) {
      if (!entries[i].isIntersecting) continue;
      var el = entries[i].target;
      io.unobserve(el);
      var g = el.getAttribute('data-mo-rv-g') || '0';
      (byGroup[g] || (byGroup[g] = [])).push(el);
    }

    for (var g2 in byGroup) {
      var list = byGroup[g2];
      /* DOM sırasına göre — görsel sıraya göre değil. (cats ızgarasında
         1. kart 2x2 hücrede duruyor ama DOM'da hâlâ birinci.)             */
      list.sort(function (a, b) {
        return (a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING) ? -1 : 1;
      });
      for (var j = 0; j < list.length; j++) {
        /* Gecikme 5 adımla sınırlı: 12 satırlık malzeme listesinde son
           satır 720ms değil en fazla 300ms bekler, sayfa ağır hissettirmez. */
        var d = Math.min(j, 5) * step;
        list[j].style.setProperty('--mo-rv-d', d + 'ms');
        list[j].style.willChange = 'opacity, transform';
        list[j].setAttribute('data-mo-rv', 'in');
      }
    }
  }

  /* ⚠️ Muhafız `data-mo-rv-g` üzerinde (durum değil, «izleniyor» işareti).
     `data-mo-rv` üzerinde olsaydı, henüz belirmemiş bir eleman ikinci bir
     taramada tekrar izlenir ve İKİNCİ bir animationend dinleyicisi alırdı. */
  function watch(el, groupIndex) {
    if (el.hasAttribute('data-mo-rv-g')) return;
    el.setAttribute('data-mo-rv-g', groupIndex);
    el.addEventListener('animationend', function h(ev) {
      if (ev.animationName !== 'moRvFloat') return;
      el.removeEventListener('animationend', h);
      finish(el);
    });
    io.observe(el);
  }

  function init(scope) {
    step = readStep();
    if (!io) {
      io = new IntersectionObserver(onEntries, {
        /* Alt kenardan %12 içeride tetikle: eleman ekranın tam kenarında
           değil, bir tık içeri girdiğinde başlasın — göze daha doğal gelir. */
        rootMargin: '0px 0px -12% 0px',
        threshold: 0.01
      });
    }
    for (var i = 0; i < GROUPS.length; i++) {
      var nodes = (scope || document).querySelectorAll(GROUPS[i]);
      for (var j = 0; j < nodes.length; j++) watch(nodes[j], i);
    }
  }

  /* --- Güvenlik ağı — İKİ KADEMELİ -------------------------------------
     Bu projede IntersectionObserver'ın HİÇ ateşlenmediği vakalar yaşandı
     (bir kez `content-visibility` etkileşimi yüzünden, bir kez sayfa hiç
     kare üretmediği için). O durumda gizli başlangıç durumu kalıcı olur ve
     kullanıcı boş sayfaya bakar. Kabul edilemez.

     KADEME 1 — «gözlemci hiç çalışmadı»: 3 sn içinde tek bir geri çağrım
     bile gelmediyse hareket fikrinden TAMAMEN vazgeç. `mo-rv-ready`
     sınıfını kaldırmak bu dosyadaki bütün gizleme kurallarını iptal eder;
     sayfa animasyonsuz ama eksiksiz görünür.
     Sessizce bozuk kalmaktansa sessizce sade kalmak yeğdir.

     KADEME 2 — «gözlemci çalıştı ama birini kaçırdı»: ekranda olup hâlâ
     gizli duran ne varsa göster. Kaydırma durdukça tekrarlanır, çünkü
     kullanıcı 3. saniyeden sonra da kaydırmaya devam ediyor.              */
  function safetyNet() {
    if (!ioFired) {
      root.classList.remove('mo-rv-ready');
      root.classList.remove('mo-intro');
      if (io) io.disconnect();
      return;
    }
    var stuck = document.querySelectorAll('[data-mo-rv-g]:not([data-mo-rv])');
    for (var i = 0; i < stuck.length; i++) {
      var r = stuck[i].getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) {
        if (io) io.unobserve(stuck[i]);
        finish(stuck[i]);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  setTimeout(safetyNet, 3000);

  var netT;
  window.addEventListener('scroll', function () {
    clearTimeout(netT);
    netT = setTimeout(safetyNet, 250);
  }, { passive: true });

  /* Shopify tema editöründe bölüm yeniden yüklenince yeni düğümleri de bağla */
  document.addEventListener('shopify:section:load', function (e) {
    try { init(e.target); } catch (err) {}
  });
})();
